
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"23","height":"23","viewBox":"0 0 23 23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"11.221","cy":"11.5","r":"11.221","fill":"#122546"}}),_c('path',{attrs:{"d":"M14.584 17.279H7.816a1.128 1.128 0 010-2.256h6.768a1.128 1.128 0 010 2.256zm1.127-4.512H6.688a1.128 1.128 0 010-2.255h9.023a1.128 1.128 0 010 2.255zm1.128-4.511H5.561A1.128 1.128 0 015.56 6h11.278a1.128 1.128 0 010 2.256z","fill":"#fff"}})])
          )
        }
      }
    